import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { z } from 'zod';
import { ApplicationsIdSchema } from '../applications.schema';
import { DetectedLoginBehaviorSchema } from './application-login-behavior.schema';

export const loginBehaviorContractRoutes = {
  getLoginBehaviorObservations: terraContract
    .meta({
      permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
    })
    .route({
      method: 'GET',
      path: '/{id}/login-behavior-observations',
      summary: 'Get login behavior learned from runtime checks',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: ApplicationsIdSchema }))
    .output(DetectedLoginBehaviorSchema),
};
